import * as jwt_decode from "jwt-decode";
import { environment } from "../../../../environments/environment";
import { PermissionAreaDto, TokenDto } from "../../server/DataTransferObject/Objects/Authentication";
import { Identity } from "../auth/identity";
import { IdentityResult } from "../auth/identity-result";
import { ContextKind } from "../../server/index-enums";

export class TokenHelper {

    public static decodeToken(token: string) {
        return jwt_decode(token);
    }

    public static getIdentityFromAppToken(appToken: TokenDto, requireLocationContext: boolean = true) {
        const currentTenant = this.getTenantFromToken(appToken);
        
        const context = TokenHelper.getContextFromToken(appToken);
        const identity = new Identity(currentTenant.displayName, appToken.token, appToken.refreshToken, currentTenant.tenantId);

        if(context == null) {
            if(!requireLocationContext)
                return new IdentityResult(identity, currentTenant.tenantId, null);
                
            throw new Error("identity must contain exactly one location context");
        }

        return new IdentityResult(identity, context.tenantId, context.locationId, currentTenant.featureFlags);
    }

    private static getTenantFromToken(appToken: TokenDto) {
        const decoded = this.decodeToken(appToken.token);
        const areas: PermissionAreaDto[] = JSON.parse(decoded.permissions);

        const contexts = areas
            .map(x => x.contexts)
            .reduce((x,y) => x.concat(y), [])
            .filter(x => x.type !== ContextKind.User);

        const tenantIds = contexts.map(x => x.tnt);
        const tenants = appToken.info.tenants.filter(x => tenantIds.includes(x.tenantId));

        if (tenants.length !== 1)
            throw new Error("identity must contain exactly one tenant");

        return tenants[0];
    }

    private static getContextFromToken(appToken: TokenDto) {
        const decoded = this.decodeToken(appToken.token);
        const areas: PermissionAreaDto[] = JSON.parse(decoded.permissions);

        const contexts = areas
            .map(x => x.contexts)
            .reduce((x,y) => x.concat(y), [])
            .filter(x => x.type !== ContextKind.User);

        const isSingleContext = contexts.length === 1;

        if (isSingleContext) {
            const context = contexts[0];
            const isContextLocation = context.type === ContextKind.Location;

            if (isContextLocation) {
                return {
                    tenantId: context.tnt,
                    locationId: context.src
                };
            }
        }

        return null;
    }

    public static getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);

        if (decoded.exp === undefined) return null;

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    public static isTokenExpired(token: string): boolean {
        if (!token) return true;

        const date = this.getTokenExpirationDate(token);
        if (date === undefined) return false;
        TokenHelper.AddExpireOffset(date);
        return !(date.valueOf() >= new Date().valueOf());
    }

    private static AddExpireOffset(date: Date) {
        date.setSeconds(date.getSeconds() - environment.apiUrl.tokenExpireOffsetSec);
    }
}
